import { Link } from "react-router-dom";
import { topics } from "@/mocks/topics";
import TopicRow from "@/components/feature/TopicRow";

export default function TodayTopic() {
  const featured = topics[0];
  const sideList = topics.filter((topic) => topic.id !== featured.id).slice(0, 4);

  return (
    <section className="mx-auto max-w-[1240px] px-4 py-12 md:px-6 md:py-16">
      <div className="flex flex-wrap items-end justify-between gap-3">
        <div>
          <span className="text-xs font-medium tracking-widest text-accent-600">DAILY TOPIC</span>
          <h2 className="mt-2 text-2xl font-bold text-foreground-950 md:text-3xl">今日话题</h2>
          <p className="mt-2 text-sm text-foreground-600">
            每天一个开放话题，接一句就算参与，看看大家的脑回路有多野。
          </p>
        </div>
        <Link
          to="/topics"
          className="flex items-center gap-1 whitespace-nowrap text-sm text-primary-700 transition-colors hover:text-primary-800"
        >
          查看全部话题
          <i className="ri-arrow-right-line" />
        </Link>
      </div>

      <div className="mt-7 grid grid-cols-1 gap-6 lg:grid-cols-3">
        <article className="overflow-hidden rounded-lg border border-background-200 bg-background-50 lg:col-span-2">
          <div className="flex flex-col md:flex-row">
            <div className="relative h-56 w-full overflow-hidden md:h-auto md:w-[46%]">
              <img
                src={featured.cover}
                alt={`${featured.title} 今日话题配图`}
                title={`${featured.title} - 瓜田社区今日话题`}
                className="h-full w-full object-cover object-top"
              />
              <span className="absolute left-3 top-3 flex items-center gap-1 rounded-full bg-accent-500 px-2.5 py-1 text-xs font-medium text-background-50">
                <i className="ri-sun-line" />
                今日置顶
              </span>
            </div>
            <div className="flex flex-1 flex-col p-5 md:p-6">
              <span className="flex items-center gap-1.5 text-xs text-foreground-500">
                <i className="ri-chat-thread-line" />
                {featured.boardName}
              </span>
              <h3 className="mt-2 text-xl font-semibold leading-snug text-foreground-950">
                <Link to={`/topic/${featured.id}`} className="transition-colors hover:text-primary-700">
                  {featured.title}
                </Link>
              </h3>
              <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground-600">
                {featured.excerpt}
              </p>
              <div className="mt-5 flex flex-wrap items-center gap-x-4 gap-y-2 text-xs text-foreground-500">
                <span className="flex items-center gap-1.5">
                  <span className="flex h-6 w-6 items-center justify-center rounded-full bg-primary-100 text-[11px] font-medium text-primary-800">
                    {featured.author.slice(0, 1)}
                  </span>
                  {featured.author}
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-chat-smile-2-line" />
                  {featured.replies} 条回帖
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-fire-line" />
                  {featured.views} 热度
                </span>
              </div>
              <Link
                to={`/topic/${featured.id}`}
                className="mt-5 flex h-10 w-fit items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                <i className="ri-chat-smile-3-line" />
                去回帖讨论
              </Link>
            </div>
          </div>
        </article>

        <div className="rounded-lg border border-background-200 bg-background-100/60 p-5">
          <h3 className="flex items-center gap-1.5 text-sm font-semibold text-foreground-950">
            <i className="ri-flashlight-line text-accent-500" />
            大家都在等新话题
          </h3>
          <div className="mt-2">
            {sideList.map((topic) => (
              <TopicRow key={topic.id} topic={topic} />
            ))}
          </div>
          <Link
            to="/topics"
            className="mt-4 flex h-10 w-full items-center justify-center gap-1.5 whitespace-nowrap rounded-md border border-primary-200 bg-primary-50 text-sm font-medium text-primary-700 transition-colors hover:bg-primary-100"
          >
            <i className="ri-add-line" />
            我也来发一个话题
          </Link>
        </div>
      </div>
    </section>
  );
}